// extracted by mini-css-extract-plugin
module.exports = {"notification":"add-to-cart_notification__PLPC8","extended-modal":"add-to-cart_extended-modal__iAqqH"};